import { SHA256 } from "crypto-js";
import { persistor } from "../redux/store";
import { useDispatch } from "react-redux";
import { USER_LOGIN_CLEAR_STATE, USER_TOKEN } from "../redux/types";

export const hashWithSalt = (password) => {
  const salt = process.env.REACT_APP_PASSWORD_SALT || '';
  return SHA256(password + salt).toString();
};

export const HandleOnclose = (dispatch)=>{
  // const dispatch  = useDispatch()
   localStorage.removeItem("userInfo"); //token
        localStorage.removeItem("token"); //token
  
        persistor.purge();
        dispatch({
          type: USER_LOGIN_CLEAR_STATE,
        });
        dispatch({
          type: USER_TOKEN,
          payload: {
            token : '',
            decodedToken: '', // Parse the JSON string
          },
        })
}